export const normalizeNumber = (value: number, normValue: number) => {
    return Math.round(value / normValue) * normValue;
};
